module.exports = __webpack_public_path__ + "media/images/mailer/vpn_key-48-white-49ae742365d4904db69614c60236bc47.png";